import React from 'react'
import useUniqueId from '../../hooks/use-unique-id'

export type RadioButtonType = {
  label: string
  value: string
}

type Props = {
  name?: string
  options: RadioButtonType[]
  value: string
  onChange: (arg0: string) => void
}

type RadioButtonProps = {
  id: string
  value: string
  name: string
  checked: boolean
  onChange: (arg0: any) => void
}

export const RadioButton = ({ id, name, value, onChange, checked }: RadioButtonProps) => (
  <input type="radio" id={id} name={name} value={value} onChange={onChange} checked={checked} />
)

export const RadioButtons = ({ name = '', options, value, onChange }: Props) => {
  const radioId = useUniqueId('radio')

  const clickEvent = (event: React.MouseEvent<HTMLLabelElement, MouseEvent>, value: string) => {
    event.preventDefault()
    onChange(value)
  }

  return (
    <>
      {options.map((option, index) => (
        <div key={index} className="c-checkbox">
          <RadioButton
            id={radioId}
            name={name}
            value={option.value}
            onChange={e => onChange(e.currentTarget.value)}
            checked={option.value === value}
          />
          <label onClick={e => clickEvent(e, option.value)} htmlFor={radioId}>{option.label}</label>
        </div>
      ))}
    </>
  )
}

export default RadioButtons
